import {
    BLUEPRINT_NAME,
    EVOLUTION_NAME,
    EZUGI_NAME,
    LEAP_NAME,
    PRAGMATIC_NAME,
    ProviderType,
    RELAX_NAME,
    SG_DIGITAL_NAME,
} from 'src/domains/casino/models/models';
import { CasinoStoreProviderZod } from 'src/api_openapi/v2/casino-store/schemas';

class CasinoProviderUtils {
    public convertNameToSlug(providerName: string): ProviderType {
        const name = CasinoStoreProviderZod.safeParse(providerName.toLowerCase().replace(/ /g, '-'));
        if (name.success) {
            return name.data;
        }
        throw new Error(`Invalid provider name: ${providerName}`);
    }

    public convertSlugToName = (provider: string): string => {
        switch (provider) {
            case 'pragmatic':
                return PRAGMATIC_NAME;
            case 'ezugi':
                return EZUGI_NAME;
            case 'evolution':
                return EVOLUTION_NAME;
            case 'leap':
                return LEAP_NAME;
            case 'relax':
                return RELAX_NAME;
            case 'blueprint':
                return BLUEPRINT_NAME;
            default:
                return SG_DIGITAL_NAME;
        }
    };
}

export const casinoProviderUtils = new CasinoProviderUtils();
